module.exports = __webpack_public_path__ + "static/img/guapai1@2x.54163e5b.png";